<wbo-edit-page #editPage [title]="model.data.name" (addingAnother)="addingAnother($event)">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.composite-product.edit.formation.compositeProductDetails',
        formControlNames: ['name', 'primaryCategory.categoryId', 'price', 'baseCostEx', 'plu', 'kiloJoules', 'taxes', 'mgtOnly']}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                            <fui-column>
                                <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                                      [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                                <wbo-checkbox-edit-control formControlName="mgtOnly"
                                                           [(ngModel)]="model.data.mgtOnly"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-append-field>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <ng-container formGroupName="primaryCategory">
                                <wbo-category-single-select-edit-control formControlName="categoryId"
                                                                         [(ngModel)]="model.data.primaryCategory.categoryId"
                                                                         [objectValue]="model.data.primaryCategory">
                                </wbo-category-single-select-edit-control>
                            </ng-container>
                            <wbo-text-edit-control formControlName="plu"
                                                   [(ngModel)]="model.data.plu"></wbo-text-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description"
                                                   [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="externalDescription"
                                                   [(ngModel)]="model.data.externalDescription"></wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-currency-edit-control formControlName="price"
                                                       [(ngModel)]="model.data.price"></wbo-currency-edit-control>
                            <wbo-currency-edit-control formControlName="baseCostEx"
                                                       [(ngModel)]="model.data.baseCostEx"></wbo-currency-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-dietary-indicator-multi-select-edit-control [(ngModel)]="model.data.dietaryIndicators"
                                                                             [multiObjectValueType]="true"
                                                                             formControlName="dietaryIndicators">
                            </wbo-dietary-indicator-multi-select-edit-control>
                            <wbo-numeric-edit-control formControlName="kiloJoules"
                                                      [notation]="'kJ'"
                                                      [(ngModel)]="model.data.kiloJoules"></wbo-numeric-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-tax-multi-select-edit-control formControlName="taxes" [multiObjectValueType]="true" [(ngModel)]="model.data.taxes">
                            </wbo-tax-multi-select-edit-control>
                            <wbo-single-select-edit-control formControlName="applyMinimumAge" [(ngModel)]="model.data.applyMinimumAge"
                                                            [clearSelectionOptionLabel]="'wbo.composite-product.edit.field.applyMinimumAge.placeholder'">
                                <wbo-select-options>
                                    <wbo-select-option [label]="'wbo.composite-product.edit.option.applyMinimumAge.yes'"
                                                       [value]="true"></wbo-select-option>
                                    <wbo-select-option [label]="'wbo.composite-product.edit.option.applyMinimumAge.no'"
                                                       [value]="false">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column formGroupName="customObjectContext">
                        <wbo-custom-object-multi-select-edit-control formControlName="customObjects" [productLineContext]="true"
                                                                     [(ngModel)]="model.data.customObjectContext.customObjects">
                        </wbo-custom-object-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-text-edit-control formControlName="receiptText"
                                           [(ngModel)]="model.data.receiptText"></wbo-text-edit-control>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.composite-product.edit.formation.images', formControlNames: ['productImage', 'icon']}">
        <wbo-sellable-edit-imagery></wbo-sellable-edit-imagery>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.composite-product.edit.formation.components', formControlNames: 'components'}">
        <wbo-edit-grid #componentsEditGrid
                       [data]="model.data.components" [editable]="true" [removable]="true"
                       [entityPath]="'components'" [reorderable]="true">
            <wbo-composite-product-component-edit-link-column></wbo-composite-product-component-edit-link-column>
            <wbo-text-column field="category"></wbo-text-column>
            <wbo-checkbox-column field="available"></wbo-checkbox-column>
            <wbo-currency-column field="price"></wbo-currency-column>
            <wbo-currency-column field="compositeLinePrice" [editable]="true"></wbo-currency-column>

            <wbo-edit-grid-add-row [customAdd]="true" #addRow>
                <wbo-edit-grid-add-row-quick-add (onSelect)="addRow.addRow($event, true, false)">
                    <wbo-composite-product-component-single-select-edit-control></wbo-composite-product-component-single-select-edit-control>
                </wbo-edit-grid-add-row-quick-add>
                <wbo-edit-grid-add-row-actions>
                    <wbo-edit-grid-add-row-search [title]="'wbo.composite-product.edit.grid-add.components.addProductLines'"
                                                  [searchComponent]="ProductLineSearchPageComponent"
                                                  (onSelect)="addFromProductLine($event)"></wbo-edit-grid-add-row-search>
                    <wbo-edit-grid-add-row-search [title]="'wbo.composite-product.edit.grid-add.components.addPlgs'"
                                                  [searchComponent]="PlgSearchPageComponent"
                                                  (onSelect)="addFromPlg($event)"></wbo-edit-grid-add-row-search>
                    <wbo-edit-grid-add-row-new-entity [title]="'wbo.composite-product.edit.grid-add.components.newProductLine'"
                                                      [editComponent]="ProductLineEditPageComponent"
                                                      (onSelect)="addFromProductLine([$event])"></wbo-edit-grid-add-row-new-entity>
                    <wbo-edit-grid-add-row-new-entity [title]="'wbo.composite-product.edit.grid-add.components.newPlg'"
                                                      [editComponent]="PlgEditPageComponent"
                                                      [editPath]="'plg'"
                                                      (onSelect)="addFromPlg([$event])"></wbo-edit-grid-add-row-new-entity>
                </wbo-edit-grid-add-row-actions>
            </wbo-edit-grid-add-row>
        </wbo-edit-grid>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.composite-product.edit.formation.priceLevels', formControlNames: ['priceLevels', 'promptForDefaultPrice']}">
        <wbo-sellable-edit-price-levels [showScaleFields]="false"></wbo-sellable-edit-price-levels>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.composite-product.edit.formation.orderingAndPreparation', formControlNames: 'tags'}">
        <fui-rows>
            <fui-row>
                <wbo-sellable-edit-barcodes [title]="'wbo.composite-product.edit.field-set.barcodes'"></wbo-sellable-edit-barcodes>
            </fui-row>
            <fui-row [label]="'wbo.composite-product.edit.field-set.dockets'">
                <fui-two-columns [formGroup]="editPage.formGroup">
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-text-edit-control formControlName="kitchenText"
                                                   [(ngModel)]="model.data.kitchenText"></wbo-text-edit-control>
                            <wbo-text-edit-control formControlName="foreignKitchenText"
                                                   [(ngModel)]="model.data.foreignKitchenText"></wbo-text-edit-control>
                        </fui-tandem-field>
                        <wbo-edit-grid [data]="docketSelectors" [editable]="false" [removable]="true" [entityPath]="'tags'"
                                       (removed)="metaTagRemoved($event)" [showHeader]="false"
                                       [title]="'wbo.composite-product.edit.field-set.docketSelectors'">
                            <wbo-edit-link-column field="name"
                                                  [editComponent]="DocketSelectorEditPageComponent"
                                                  [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                            <wbo-edit-grid-add-row [customAdd]="true" (onSearchSelect)="selectMetaTag($event)" (onNewSelect)="selectMetaTag([$event])">
                                <wbo-edit-grid-add-row-quick-add>
                                    <wbo-meta-tag-single-select-edit-control [type]="MetaTagType.DOCKET_SELECTOR">
                                    </wbo-meta-tag-single-select-edit-control>
                                </wbo-edit-grid-add-row-quick-add>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-search [searchComponent]="DocketSelectorSearchPageComponent">
                                    </wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-new-entity [editComponent]="DocketSelectorEditPageComponent">
                                    </wbo-edit-grid-add-row-new-entity>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-numeric-edit-control formControlName="printPriority"
                                                      [(ngModel)]="model.data.printPriority"></wbo-numeric-edit-control>
                            <wbo-single-select-edit-control formControlName="styleType"
                                                            [(ngModel)]="model.data.styleType">
                                <wbo-select-options>
                                    <wbo-select-option [value]="1"
                                                       label="wbo.product-line.edit.option.styleType.standard">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="2"
                                                       label="wbo.product-line.edit.option.styleType.alternate">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                        </fui-tandem-field>
                        <fui-inline-information [title]="'wbo.common.info.information'" *ngIf="docketSelectors.length"
                                                [message]="'wbo.composite-product.edit.message.tagComponents'"></fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            visible: Plugin.LOYALTY | booleanConfig,
            title: 'wbo.composite-product.edit.formation.memberLoyalty',
            formControlNames: 'memberLoyalty'
        }">
        <fui-rows>
            <fui-row>
                <fui-columns>
                    <fui-column>
                        <wbo-edit-grid [data]="loyaltySpecData" [editable]="true"
                                       [entityPath]="'memberLoyalty.memberTypeSpecs'"
                                       (saved)="memberLoyaltySaved($event)">
                            <wbo-column field="membershipType.name">
                                <ng-template cellTemplate let-dataItem="dataItem">
                                    <ng-container *ngIf="dataItem.membershipType.membershipTypeId != undefined">
                                        <wbo-edit-link [dataItem]="dataItem" field="membershipType.name"
                                                       [editComponent]="MembershipTypeEditPageComponent"
                                                       componentPath="membershipType"
                                                       [editMode]="EditMode.VIEW"></wbo-edit-link>
                                    </ng-container>
                                    <ng-container *ngIf="dataItem.membershipType.membershipTypeId == undefined">
                                        {{'wbo.product-line.edit.label.memberLoyalty.productDefaults' | translate}}
                                    </ng-container>
                                </ng-template>
                            </wbo-column>
                            <wbo-member-loyalty-accrual-type-single-select-column field="accrual.type"
                                                                                  membershipTypeField="membershipType"
                                                                                  [editable]="true">
                            </wbo-member-loyalty-accrual-type-single-select-column>
                            <wbo-numeric-column field="accrual.value" [editable]="true">
                            </wbo-numeric-column>
                            <wbo-member-loyalty-redemption-type-single-select-column field="redemption.type"
                                                                                     membershipTypeField="membershipType"
                                                                                     [editable]="true">
                            </wbo-member-loyalty-redemption-type-single-select-column>
                            <wbo-numeric-column field="redemption.value" [editable]="true">
                            </wbo-numeric-column>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns [formGroup]="editPage.formGroup">
                    <fui-column formGroupName="memberLoyalty">
                        <wbo-date-edit-control formControlName="newExpiry"
                                               [(ngModel)]="model.data.memberLoyalty.newExpiry">
                        </wbo-date-edit-control>
                    </fui-column>
                    <fui-column formGroupName="memberLoyalty">
                        <wbo-numeric-edit-control formControlName="daysToExtendExpiryBy"
                                                  [(ngModel)]="model.data.memberLoyalty.daysToExtendExpiryBy">
                        </wbo-numeric-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
